import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/product_parameters'

export default {
  namespaced: true,
  state: {
    dataList: [], // mevcut kayıtların listesi
    dataItem: {   // yeni eklenecek item (formdaki alanlar)
      id: null,
      title: '',
      value: '',
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },

  getters: {
    dataList: s => s.dataList,
    dataItem: s => s.dataItem,
    dataSaveStatus: s => s.dataSave,
  },

  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = Array.isArray(data) ? data : (data ? [data] : [])
    },
    SET_DATA_ITEM(state, obj) {
      state.dataItem = { ...state.dataItem, ...obj }
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = { id: null, title: '', value: '' }
    },
    PREPEND_DATA_ITEM(state, obj) {
      state.dataList = [obj, ...state.dataList]
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
  },

  actions: {
    async getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            commit('SET_DATA_LIST', response.data.data)
          })
          .catch(error => console.error(error))
      commit('RESET_DATA_ITEM') // formu temiz tut
    },
    // async getDataList({ commit }) {
    //   const { data } = await axiosIns.post(ROOT_URL)
    //   commit('SET_DATA_LIST', data?.data ?? [])
    //   commit('RESET_DATA_ITEM') // formu temiz tut
    // },

    async saveDataItem({ state, commit }, payload) {
      // payload verilmediyse store’daki dataItem’ı kullan
      const body = payload || state.dataItem
      const { data } = await axiosIns.post(`${ROOT_URL}/saveData`, body)

      // API kaydedilen item'ı geri döndürmüyorsa body’yi listeye ekle
      const saved = data?.data || body

      commit('PREPEND_DATA_ITEM', saved)   // üstte gözüksün
      commit('RESET_DATA_ITEM')            // formu temizle
      commit('SET_DATA_SAVE', data)
    },
    removeData({ commit }, id) {
      axiosIns
          .post(`${ROOT_URL}/deleteData`, { id })
          .then(response => {
            commit('SET_DATA_SAVE', response.data)
          })
          .catch(error => console.error(error))
    },
  },
}
